import Chip from '@components/Chip';
import useGlobalName from '@hooks/useGlobalName';
import { ItemCategory as ItemCategoryResponse } from '@models/item/itemCategory';

import useCategoryIcon from './hooks/useCategoryIcon';
import useSelectCategory from './hooks/useSelectCategory';

interface Props {
    itemCategory: ItemCategoryResponse;
    categories: ItemCategoryResponse[];
}

function ItemCategory({
    itemCategory, categories,
}:Props) {
    const {
        name, nameKo, nameJa, nameEn,
    } = itemCategory;
    const categoryName = useGlobalName({
        nameKo, nameEn, nameJa, name,
    });
    const { handleSelectCategory, isSelected } = useSelectCategory(itemCategory, categories);
    const icon = useCategoryIcon(itemCategory);

    return (
        <Chip isSelected={isSelected}
            icon={icon}
            onClick={handleSelectCategory} >
            {categoryName}
        </Chip>
    );
}

export default ItemCategory;
